(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
if(!customElements.get('cp-gift-photos')){
customElements.define('cp-gift-photos',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('.cp-gift-photo-track');const controls=this.querySelector('.cp-gift-photo-controls');if(!controls)return;controls.hidden=false;const count=track.children.length;const counter=this.querySelector('.cp-gift-photo-counter');const move=(direction)=>{const index=Math.round(track.scrollLeft/track.clientWidth);track.scrollTo({left:((index+direction+count)%count)*track.clientWidth});};this.querySelector('[data-prev]').addEventListener('click',()=>move(-1));this.querySelector('[data-next]').addEventListener('click',()=>move(1));track.addEventListener('scroll',()=>{counter.textContent=(Math.round(track.scrollLeft/track.clientWidth)+1)+' / '+count;},{passive:true});}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curvy-contact"]) return;
  try {
    
if(!customElements.get('cp-enquiry-fields')){
customElements.define('cp-enquiry-fields',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const type=this.querySelector('#EnquiryType');const fields=this.querySelector('#WorkplaceFields');
if(new URLSearchParams(window.location.search).get('enquiry')==='corporate')type.value='corporate';
const update=()=>{fields.hidden=type.value!=='corporate';};
type.addEventListener('change',update);update();
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curvy-corporate"]) return;
  try {
    
if (!customElements.get('cp-corp-carousel')) {
customElements.define('cp-corp-carousel',class extends HTMLElement {
connectedCallback(){
if(this.ready)return;this.ready=true;this.slides=[...this.querySelectorAll('.cp-corp-slide')];this.index=0;
if(this.slides.length<2)return;
this.querySelector('.cp-corp-carousel-controls').hidden=false;
this.querySelector('[data-prev]').addEventListener('click',()=>this.show(this.index-1));
this.querySelector('[data-next]').addEventListener('click',()=>this.show(this.index+1));
this.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1));}});
this.show(0);
}
show(index){this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((s,i)=>{s.hidden=i!==this.index;});this.querySelector('[data-count]').textContent=(this.index+1)+' / '+this.slides.length;}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curvy-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cp-photo-carousel')) {
  customElements.define('cp-photo-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('.cp-photo-slide')];
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      if (this.slides.length < 2) return;
      this.querySelector('.cp-photo-controls').hidden = false;
      this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
        slide.setAttribute('aria-hidden', String(i !== this.index));
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
